﻿export class FileUploaderModel {
    File: any;
    Name: string = "";
    Extension: string = "";
    Size: number = 0;
    IsValid: boolean = true;
    IsChanged: boolean = false;
}